import { UnitState, CustomAction } from "model/state";
import { UnitPayload } from "actions/Unit";
import {
  FETCH_UNIT_DETAILS_SUCCESS, RECEIVE_DEVICE_REALTIME_DATA, REMOVE_DEVICES_FROM_SUBSCRIPTION_MAP, CLEAN_UNIT_DETAILS,
  SET_CURRENT_DEVICE, FETCH_ALERTS_BY_LOCATION_SUCCESS, FETCH_ALERTS_BY_LOCATION, FETCH_UNIT_DETAILS,
  FETCH_UNIT_DETAILS_ERROR, CLEAR_ALERT_SUCCESS, FETCH_AREA_TEMPERATURE_BY_LOCATION_SUCCESS,
  REFRESH_UNIT_DETAILS_SUCCESS
} from "constants/ActionTypes";
import { Device, Unit, RealTimeDeviceData, AlertStatus } from "model";
import { RealtimePayload, AlertPayload, ConsumptionPayload } from "actions";

const initialState: UnitState = {
  currentUnit: undefined,
  currentMacAddress: undefined,
  isLoadingUnit: false,
  realTimeData: {},
  alerts: {
    list: [],
    isLoading: false,
  },
  pendingAlerts: [],
};

function getDefaultDevice(unit?: Unit): string | undefined {
  const devices: Device[] = unit?.devices || [];
  return devices.length > 0 ? devices[0].macAddress : undefined;
}

function unitReducer(state: UnitState | undefined = initialState, action: CustomAction<UnitPayload & RealtimePayload & AlertPayload & ConsumptionPayload>) {
  switch (action.type) {
    case FETCH_UNIT_DETAILS: {
      return { ...state, isLoadingUnit: true };
    }

    case FETCH_UNIT_DETAILS_SUCCESS: {
      return {
        ...state,
        currentUnit: action.payload?.unit,
        currentMacAddress: getDefaultDevice(action.payload?.unit),
        isLoadingUnit: false,
      }
    }

    case REFRESH_UNIT_DETAILS_SUCCESS: {
      return {
        ...state,
        currentUnit: action.payload?.unit,
      }
    }

    case FETCH_UNIT_DETAILS_ERROR: {
      return { ...state, isLoadingUnit: false };
    }

    case RECEIVE_DEVICE_REALTIME_DATA: {
      const data = action.payload?.data as RealTimeDeviceData;
      const macAddress = data.macAddress;
      if (!macAddress) {
        return state;
      }
      return {
        ...state,
        realTimeData: {
          ...state.realTimeData,
          [macAddress]: {
            ...state.realTimeData[macAddress],
            ...data
          }
        }
      };
    }

    case REMOVE_DEVICES_FROM_SUBSCRIPTION_MAP: {
      const realTimeData = { ...state.realTimeData };

      (action.payload?.macAddresses || []).forEach((macAddress) => {
        delete realTimeData[macAddress];
      });
      return { ...state, realTimeData };
    }

    case CLEAN_UNIT_DETAILS: {
      return {
        ...state,
        currentUnit: initialState.currentUnit,
        currentMacAddress: initialState.currentMacAddress,
      }
    }

    case SET_CURRENT_DEVICE: {
      return {
        ...state,
        currentMacAddress: action.payload?.macAddress
      }
    }

    case FETCH_ALERTS_BY_LOCATION: {
      return { ...state, alerts: { ...state.alerts, isLoading: true }, pendingAlerts: [] };
    }

    case FETCH_ALERTS_BY_LOCATION_SUCCESS: {
      return {
        ...state,
        alerts: {
          list: action.payload?.alerts || [],
          isLoading: false,
        },
        pendingAlerts: action.payload?.pendingAlerts || [],
      }
    }

    case CLEAR_ALERT_SUCCESS: {
      const index = state.alerts.list.findIndex(alert => alert.id === action.payload?.alert?.id);
      if (index === undefined) {
        return { ...state }
      }
      const current = state.alerts.list[index];
      if (current === undefined) {
        return { ...state }
      }
      const newRows = [
        ...state.alerts.list.slice(0, index) || [],
        {
          ...current,
          status: AlertStatus.RESOLVED,
        },
        ...state.alerts.list.slice(index + 1) || []
      ]

      return {
        ...state,
        alerts: {
          ...state.alerts,
          list: newRows,
        },
        pendingAlerts: state?.pendingAlerts.filter(a => a.id !== action.payload?.alert?.id) || [],
      };
    }

    case FETCH_AREA_TEMPERATURE_BY_LOCATION_SUCCESS: {
      return {
        ...state,
        areaTemperature: action.payload?.areaTemperature,
      }
    }

    default:
      return state
  }
}

export default unitReducer;
